var exports = {
  "preloader": "xdbfd91f1--6ccb32--preloader",
  "e": "xdbfd91f1--6ccb32--rotate",
};

module.exports = exports;
